import { yupResolver } from "@hookform/resolvers/yup";
import FormInput from "components/Common/Form/FormInput";
import { useMappingRefCodeUnknownToOrder } from "hooks";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as yup from "yup";

const MappingUnknownRefCodeToOrderModal = ({
  dataMapping,
  isOpen,
  toggle,
  onSuccessMappingHandle,
}) => {
  const { addToast } = useToasts();
  const { t, i18n } = useTranslation(["order"]);

  const [errorMessage, setErrorMessage] = useState(null);

  const schema = yup.object().shape({
    order_code: yup.string().required("Vui lòng nhập Mã đơn").nullable(),
  });

  const mainForm = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const {
    reset,
    formState: { errors },
    control,
    getValues,
    setValue,
    register,
    trigger,
    handleSubmit,
  } = mainForm;

  useEffect(() => {
    if (isOpen) {
      setValue("order_code", null);
      setErrorMessage("");
    }
  }, [isOpen]);

  const onSuccessMapping = _data => {
    if (_data?.result) {
      addToast(
        t("message.mappingRefCodeUnknownToOrder", {
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      toggle();
      onSuccessMappingHandle();
    } else {
      addToast(
        t("message.mappingRefCodeUnknownToOrder", {
          status: t("message.error"),
        }),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof _data?.message === "string") {
        setErrorMessage(_data?.message);
      } else {
        const fields = Object.keys(_data?.message);
        const errorMessage = fields.reduce((acc, field) => {
          // if is last field, not add dot to end of string
          if (field === fields[fields.length - 1]) {
            return acc + _data?.message?.[field]?.[0];
          }
          return acc + _data?.message?.[field]?.[0] + ", ";
        }, " ");
        setErrorMessage(errorMessage);
      }
    }
  };

  const {
    isLoading: isLoadingMappingRefCode,
    mutate: mutateMappingRefCode,
    data: dataMappingRefCode,
    reset: resetMappingRefCode,
  } = useMappingRefCodeUnknownToOrder(onSuccessMapping);

  const onSubmit = values => {
    mutateMappingRefCode({
      parent_id: dataMapping?.parent_id,
      ref_code: dataMapping?.ref_code,
      order_code: values?.order_code,
    });
  };

  return (
    <Modal
      size="lg"
      role="dialog"
      autoFocus={true}
      centered={true}
      isOpen={isOpen}
      toggle={toggle()}
    >
      <ModalHeader toggle={toggle()}>Cập nhật mã tham chiếu</ModalHeader>
      <ModalBody>
        <div
          className="mb-2"
          style={{
            fontStyle: "italic",
            fontWeight: "500",
          }}
        >
          Hệ thống sẽ cập nhật mã tham chiếu{" "}
          {dataMapping?.ref_code ? (
            <>
              <span className="text-primary">{dataMapping?.ref_code}</span> của
              kiện{" "}
            </>
          ) : (
            "phù hợp "
          )}
          cho đơn có trên hệ thống. Đơn này sẽ được thêm vào đơn lấy hàng chành
          xe <span className="text-info">{dataMapping?.parent_code}</span> hiện
          tại
        </div>
        <Label>
          Mã đơn muốn cập nhật
          <span className="text-danger">*</span>
        </Label>
        <FormInput
          isLabel={false}
          isRequired
          mainForm={mainForm}
          fieldName="order_code"
          type="text"
          t={t}
          title={"Mã đơn muốn cập nhật"}
          placeholder={""}
        />
        {errorMessage && (
          <div className="d-flex gap-1 align-items-center">
            <i
              className="bx bx-error text-danger"
              style={{ fontSize: "17px" }}
            />
            <div
              className="text-danger"
              style={{
                marginTop: "3px",
              }}
            >
              {errorMessage}
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          color="danger"
          // disabled={isDisableButton}
          className="me-2 btn-label"
          onClick={() => toggle()}
        >
          <i className="bx bx-x label-icon" />
          Đóng
        </Button>
        <Button
          type="button"
          color="success"
          className="me-2 btn-label"
          disabled={isLoadingMappingRefCode}
          onClick={() => {
            handleSubmit(onSubmit)();
          }}
        >
          <i className="bx bx-check label-icon" />
          Xác nhận
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MappingUnknownRefCodeToOrderModal;
